import { HttpStatusCode } from "axios";
import Lottie from "lottie-react";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import {
  toastUtils,
  formatedPhoneNumber,
  getRawPhoneNumber,
  filterInputValidation,
} from "../../../Utils/helper";
import Button from "../../../components/common/Button/Button";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import BodyModalLoading from "../../../components/common/Modal/BodyModalLoading/BodyModalLoading";
import CommonModal from "../../../components/common/Modal/ModalCommon";
import Slider from "../../../components/common/RangeSlider/Slider";
import UploadComponent from "../../../components/common/UploadFile/UploadComponent";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import ProgressDotGroup from "../../../components/ProgressBar/ProgressDotGroup";
import TextScroll from "../../../components/v6/Text/TextScroll";
import { useUploadProgress } from "../../../hooks/useUploadProgress";
import images from "../../../images";
import {
  apiSlice,
  useGetQuestDetailsQuery,
  useGetTakeQuestQuery,
  useLazyGetDetailParticipantQuery,
  useLazyGetTimeExtensionQuery,
  // useLazyGetTakeQuestPracticeQuery,
  usePostAnswerMutation,
  usePostCreateReferralCodeMutation,
  usePostEndQuestMutation,
  usePostPauseTimerParticipantMutation,
  usePostQuestReviewMutation,
  usePostSaveQuestMutation,
  usePostTakeQuestCompleteMutation,
  // usePostCreateReferralCodeMutation,
} from "../../../services/apiSlice";
import { QuestionType } from "../../../Utils/enum";
import {
  cn,
  formatDateToFakeMicroUTC,
  isSelectedForRequiredQuest,
  renderWithBold,
} from "../../../Utils/helper";
import AnswerOption from "./AnswerOption";
import AnswerYesNoQuestion from "./AnswerYesNoQuestion";
import HeaderQuestPratice from "./HeaderQuestPratice";
import QuestionCard from "./QuestionCard";
import StepQuestComplete from "./Step/StepQuestComplete";
import Timer from "./Timer";
import TimerTypeOclock from "./TimerTypeOclock";
import CustomInputProps from "../../../components/CustomInputProps/CustomInputProps";
import { useQuestValidation } from "../../../hooks/useQuestValidation";

const ANSWER_OPTION_TYPES = [QuestionType.MCQ, QuestionType.CHECKBOX];
const ANSWER_TEXT_TYPES = [QuestionType.SHORT, QuestionType.LONG];
const ANSWER_SLIDER_TYPES = [QuestionType.SLIDER];
const ANSWER_YESNO_TYPES = [QuestionType.YESNO];

const DetailMultipleChoice = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const questId = searchParams.get("quest_id");
  const locationId = searchParams.get("location_id");

  const isValidationReceipt =
    searchParams.get("is_validation_receipt") === "true";

  const expiredAtStrParam = searchParams.get("expired_at") ?? "";

  const [expiredAtTime, setExpiredAtTime] = useState(expiredAtStrParam);
  const [quotaType, setQuotaType] = useState("");
  const [referralName, setReferralName] = useState("");
  const [referralMessage, setReferralMessage] = useState("");
  const [referralDisplayName, setReferralDisplayName] = useState("");
  const [referralPhoneNumber, setReferralPhoneNumber] = useState("");
  const [postCreateReferralCode, { isLoading: isCreatingCode }] =
    usePostCreateReferralCodeMutation();

  const expiredAtStr = expiredAtTime;

  const now = new Date();
  const nowUTCISOString = formatDateToFakeMicroUTC(now);

  const { progress, startProgress, completeProgress, resetProgress } =
    useUploadProgress();

  let expiredDate;

  try {
    if (expiredAtStr === "" || typeof expiredAtStr !== "string") {
      throw new Error("Invalid expiration time (not a string)");
    }

    const slicedStr = expiredAtStr.slice(0, 23);
    expiredDate = new Date(slicedStr);

    if (isNaN(expiredDate.getTime())) {
      throw new Error("Invalid date format");
    }
  } catch (error) {
    console.error("❌ Error parsing expiredAtTime:", error.message);
    expiredDate = new Date(); // fallback
  }
  const nowDate = new Date(nowUTCISOString.slice(0, 23));
  const diffMs = expiredDate.getTime() - nowDate.getTime();
  const diffSeconds = Math.round(diffMs / 1000);
  const validateDiffSeconds = diffSeconds <= 0 ? 0 : diffSeconds;

  const sttDone =
    searchParams.get("stt_done") === "null"
      ? null
      : parseInt(searchParams.get("stt_done"), 10);

  const [isPostAnswering, setIsPostAnswering] = useState(false);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isPrevStepLoading, setIsPrevStepLoading] = useState(false);
  const [submittedSteps, setSubmittedSteps] = useState([]);
  const [congratulation, setCongratulation] = useState(false);
  const [isCompletingQuest, setIsCompletingQuest] = useState(false);

  const isPrevStepLoadingRef = useRef(false);
  const pauseRef = useRef();
  const endRef = useRef();
  const submitRef = useRef();
  const reviewingRef = useRef();
  const reviewCompleteRef = useRef();
  const reviewingCompleteRef = useRef();
  const outQuestModelRef = useRef();
  const timeIsRunningRef = useRef(true);
  const confirmSaveAndQuitRef = useRef();
  const reviewQuestModalRef = useRef(null);
  const editQuestModalRef = useRef(null);
  const completeReviewModalRef = useRef(null);
  const isNavigatingRef = useRef(false);
  const contentRef = useRef(null);

  const modalRefs = useMemo(
    () => ({
      pause: pauseRef,
      end: endRef,
      submit: submitRef,
      reviewing: reviewingRef,
      reviewComplete: reviewCompleteRef,
      reviewingComplete: reviewingCompleteRef,
      outQuest: outQuestModelRef,
      timeIsRunning: timeIsRunningRef,
      confirmSaveAndQuit: confirmSaveAndQuitRef,
      reviewQuestModal: reviewQuestModalRef,
      editQuestModal: editQuestModalRef,
      completeReviewModal: completeReviewModalRef,
    }),
    [],
  );

  const [state, setState] = useState({
    time: validateDiffSeconds,
    // currentStep:
    //   sttDone && !isNaN(sttDone)
    //     ? Math.max(1, sttDone)
    //     : isValidationReceipt
    //     ? 1
    //     : 2,
    currentStep: sttDone && !isNaN(sttDone) ? Math.max(1, sttDone) : 1,
    selectedOption: { id: null, is_correct: null },
    selectedOptions: [],
    additionalComment: "",
    answerText: "",
    receiptFiles: [],
    fileAlreadyUploaded: false,
    isFromReview: false,
    questErrors: {},
    questSteps: {},
    questAnswers: {},
    inErrorReviewMode: false,
    currentErrorIndex: 0,
    errorQuestionsList: [],
    otherOptionTexts: {},
    isSubmitting: false,
    reviewMode: false,
    errorStepsArray: [],
    currentErrorStepIndex: 0,
    checkRunningTime: false,
  });
  const [hasOtherError, setHasOtherError] = useState(false);
  const [isReviewingDataResponse, setIsReviewingDataResponse] = useState(null);

  const { data, isLoading: isQuestLoading } = useGetTakeQuestQuery({
    quest_id: questId,
  });

  const [triggerTimeExtension, { isLoading: isTimeRunningLoading }] =
    useLazyGetTimeExtensionQuery();
  const [postAnswer] = usePostAnswerMutation();
  const [postQuestReview] = usePostQuestReviewMutation();
  const [getDetailsPractice] = useLazyGetDetailParticipantQuery();

  const [postEndQuest] = usePostEndQuestMutation();
  const [postSaveQuest] = usePostSaveQuestMutation();

  const [postFileTakeQuestComplete] = usePostTakeQuestCompleteMutation();
  const [postPauseTimerParticipant] = usePostPauseTimerParticipantMutation();
  const { data: questDetailsData } = useGetQuestDetailsQuery(
    { quest_id: questId },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const questType = questDetailsData?.data?.quest_business?.quest_type;
  const isDeepDiveQuest = questType === "DEEP_DIVE";

  const thumbnailPaths =
    questDetailsData?.data.thumbnails?.map(
      (thumbnail) => thumbnail.file_path,
    ) || [];

  const totalSteps = (data?.data?.length || 0) + (isValidationReceipt ? 1 : 0);
  const currentStepData = useMemo(() => {
    if (!data?.data) return null;

    if (isValidationReceipt) {
      return state.currentStep > 1 ? data.data[state.currentStep - 2] : null;
    }

    return data.data[state.currentStep - 1];
  }, [state.currentStep, data?.data, isValidationReceipt]);

  // useEffect(() => {
  //   // Ẩn widget khi vào trang
  //   dispatch(setHideWidget(true));
  // }, [dispatch]);
  useEffect(() => {
    let timer;

    const updateTime = () => {
      if (!expiredAtStr || typeof expiredAtStr !== "string") return;

      const now = new Date();
      const nowUTCISOString = formatDateToFakeMicroUTC(now);

      const expiredDate = new Date(expiredAtStr.slice(0, 23));
      const nowDate = new Date(nowUTCISOString.slice(0, 23));

      const diffMs = expiredDate.getTime() - nowDate.getTime();
      const diffSeconds = Math.max(0, Math.round(diffMs / 1000));

      setState((prev) => ({
        ...prev,
        time: diffSeconds,
      }));

      if (
        diffSeconds > 0 &&
        diffSeconds <= 30 &&
        quotaType === "SLOT" &&
        state.checkRunningTime === false
      ) {
        timeIsRunningRef.current?.openModal();
      } else if (diffSeconds <= 0) {
        timeIsRunningRef.current?.closeModal();
        outQuestModelRef.current?.openModal();
        clearInterval(timer);
      }
    };

    timer = setInterval(updateTime, 1000);
    updateTime();

    return () => clearInterval(timer);
  }, [questId, expiredAtStr, state.checkRunningTime, quotaType]);

  useEffect(() => {
    const fetchQuest = async () => {
      setIsLoading(true);
      try {
        const response = await getDetailsPractice({
          participant_id: id,
        }).unwrap();

        if (response.message === "Creation successful") {
          const selectedItem = response.data;
          if (selectedItem) {
            setExpiredAtTime(selectedItem.expired_at || null);
            setQuotaType(
              selectedItem?.quest?.quest_business?.quota_type ??
                questDetailsData?.data?.quest_business?.quota_type,
            );
          } else {
            console.warn("No matching item found for ID:", id);
            setExpiredAtTime(null);
          }
          const questAnswers = {};
          const receiptLength = selectedItem?.receipt?.length || 0;
          if (receiptLength !== 0 && sttDone && !isNaN(sttDone)) {
            setState((prev) => ({
              ...prev,
              currentStep: Math.min(sttDone + 1, totalSteps),
            }));
          }
          const groupedAnswers = selectedItem?.quest_participant_answers.reduce(
            (acc, item) => {
              if (!acc[item.quest_question_id]) {
                acc[item.quest_question_id] = [];
              }
              acc[item.quest_question_id].push(item);
              return acc;
            },
            {},
          );

          Object.entries(groupedAnswers).forEach(([questionId, answers]) => {
            const questionData = data?.data?.find(
              (q) => String(q.id) === String(questionId),
            );
            const isCheckbox = questionData?.type === QuestionType.CHECKBOX;

            if (isCheckbox) {
              const optionIds = answers
                .map((a) => a.quest_question_option_id)
                .filter(Boolean);
              questAnswers[questionId] = {
                quest_question_id: questionId,
                quest_question_option_ids: optionIds,
                quest_question_option_id: optionIds[0] || null,
                is_correct: false,
                additional_comment: answers[0]?.additional_comment || "",
                answer_text:
                  answers.find((a) => !!a.answer_text)?.answer_text || "",
              };
            } else {
              const answer = answers[0];
              questAnswers[questionId] = {
                quest_question_id: questionId,
                quest_question_option_id:
                  answer.quest_question_option_id || null,
                quest_question_option_ids: answer.quest_question_option_id
                  ? [answer.quest_question_option_id]
                  : [],
                is_correct: answer.is_correct || false,
                additional_comment: answer.additional_comment || "",
                answer_text: answer.answer_text || "",
              };
            }
          });

          const otherOptionTexts = {};
          selectedItem?.quest_participant_answers.forEach((answer) => {
            const questionData = data?.data?.find(
              (q) => q.id === answer.quest_question_id,
            );
            const selectedOption = questionData?.quest_question_option?.find(
              (opt) => opt.id === answer.quest_question_option_id,
            );
            if (selectedOption?.is_other_option && answer.answer_text) {
              otherOptionTexts[answer.quest_question_id] = answer.answer_text;
            }
          });

          setState((prev) => ({
            ...prev,
            receiptFiles: selectedItem?.receipt || [],
            isFromReview: Object.keys(questAnswers).length > 0,
            questAnswers,
            otherOptionTexts,
            fileAlreadyUploaded: receiptLength > 0,
          }));
        }
      } catch (err) {
        console.error("Failed to fetch quest:", err);
        toastUtils.error(t("toast.error.failedToFetchQuest"));
        navigate("/");
      } finally {
        setIsLoading(false);
      }
    };

    fetchQuest();
  }, [
    questId,
    getDetailsPractice,
    data?.data,
    sttDone,
    totalSteps,
    t,
    navigate,
    questDetailsData?.data?.quest_business?.quota_type,
    id,
  ]);

  useEffect(() => {
    const stepOffset = isValidationReceipt ? 2 : 1;
    if (data?.data) {
      const questSteps = data?.data.reduce(
        (acc, question, index) => ({
          ...acc,
          [question.id]: index + stepOffset,
        }),
        {},
      );
      setState((prev) => ({
        ...prev,
        questSteps,
        currentStep: Math.min(prev.currentStep, totalSteps),
      }));
    }
  }, [data, totalSteps, isValidationReceipt]);

  useEffect(() => {
    if (!currentStepData) return;

    const currentData = state.questAnswers?.[currentStepData?.id];
    let selectedOption = {
      id: currentData?.quest_question_option_id || null,
      is_correct: currentData?.is_correct || false,
    };

    let selectedOptions = [];
    if (
      currentStepData?.type === QuestionType.CHECKBOX &&
      currentData?.quest_question_option_ids?.length > 0
    ) {
      selectedOptions = currentData.quest_question_option_ids.map((optId) => {
        const option = currentStepData.quest_question_option?.find(
          (opt) => opt.id === optId,
        );
        return {
          id: optId,
          is_correct: option?.is_correct || false,
        };
      });
    } else if (selectedOption.id) {
      selectedOptions = [selectedOption];
    }

    setState((prev) => ({
      ...prev,
      answerText: currentData?.answer_text || "",
      additionalComment: currentData?.additional_comment || "",
      selectedOption,
      selectedOptions,
    }));
  }, [state.questAnswers, state.currentStep, currentStepData]);

  const { mainAnswerValidation, remarkValidation } = useQuestValidation(
    currentStepData,
    state.answerText,
    state.additionalComment,
  );

  const handleAnswerChange = useCallback(
    (field, value) => {
      setState((prev) => {
        const currentErrors = { ...prev.questErrors };

        if (currentStepData?.id && currentErrors[currentStepData.id]) {
          currentErrors[currentStepData.id] = {
            ...currentErrors[currentStepData.id],
            hideBorder: true,
          };
        }

        return {
          ...prev,
          [field]: filterInputValidation(
            currentStepData.input_validation,
            value,
          ),
          questErrors: currentErrors,
        };
      });
    },
    [currentStepData],
  );

  const renderCounter = (validation) => {
    if (!validation) return null;
    const { length, min, max, unitKey, isStrictLength } = validation;

    const getUnit = (count) =>
      t(`quest.detailMultipleChoice.units.${unitKey}`, { count });

    return (
      <div className="text-sm text-gray-500 flex justify-end items-end mt-1">
        {isStrictLength ? (
          <span>
            {t("quest.detailMultipleChoice.counter.required", {
              current: length,
              min,
              unit: getUnit(min),
            })}
          </span>
        ) : (
          <span>
            {length} /{" "}
            {max
              ? t("quest.detailMultipleChoice.counter.max", {
                  max,
                  unit: getUnit(max),
                })
              : t("quest.detailMultipleChoice.counter.min", {
                  min,
                  unit: getUnit(min),
                })}
          </span>
        )}
      </div>
    );
  };

  const handleReferralShare = async () => {
    if (!referralName.trim()) {
      toastUtils.error(
        t("referral.nameRequired") || "Please enter recipient's name",
      );
      return;
    }
    if (!referralPhoneNumber.trim()) {
      toastUtils.error(
        t("referral.recipientNumberRequired") ||
          "Please enter recipient's whatsapp number",
      );
      return;
    }
    if (!referralDisplayName.trim()) {
      toastUtils.error(
        t("referral.yourDisplayNameRequired") ||
          "Please enter your display name",
      );
      return;
    }

    try {
      const questBusinessId = questDetailsData?.data?.quest_business?.id;
      if (!questBusinessId) {
        toastUtils.error("Quest Business ID not found");
        return;
      }

      const response = await postCreateReferralCode({
        quest_business_id: questBusinessId,
        referral_name: referralDisplayName,
        referral_message: referralMessage,
        recipient_name: referralName,
        recipient_number: getRawPhoneNumber(referralPhoneNumber),
        recipient_country_code: "+65",
      }).unwrap();

      const code = response?.data?.referral_code;

      if (!code) {
        throw new Error("No code returned from API");
      }

      // Điều hướng ngay sau khi tạo mã thành công
      navigate("/quest/details/reward-pending", {
        state: { questDetailsData: questDetailsData?.data },
      });
      return;
    } catch (error) {
      if (error?.name === "AbortError") return;

      const apiMsg =
        error?.data?.detail ||
        error?.message ||
        t("toast.error.failedToGenerateShareLink") ||
        "Failed to generate share link";
      console.error("postCreateReferralCode failed:", error);
      toastUtils.error(apiMsg);
    }
  };

  const handleSelect = useCallback(
    (optionId, isCorrect) => {
      if (!currentStepData) return;
      const isCheckbox = currentStepData?.type === QuestionType.CHECKBOX;

      setState((prevState) => {
        let newSelectedOptions = [...prevState.selectedOptions];
        if (isCheckbox) {
          const isAlreadySelected = newSelectedOptions.some(
            (opt) => opt.id === optionId,
          );
          if (isAlreadySelected) {
            newSelectedOptions = newSelectedOptions.filter(
              (opt) => opt.id !== optionId,
            );
          } else {
            newSelectedOptions.push({ id: optionId, is_correct: isCorrect });
          }
        } else {
          newSelectedOptions = [{ id: optionId, is_correct: isCorrect }];
        }

        return {
          ...prevState,
          selectedOptions: newSelectedOptions,
          selectedOption: isCheckbox
            ? newSelectedOptions[0] || { id: null, is_correct: null }
            : { id: optionId, is_correct: isCorrect },
        };
      });
    },
    [currentStepData],
  );

  const handleFileUpload = useCallback((newFiles) => {
    if (!newFiles || newFiles.length === 0) {
      setState((prevState) => ({
        ...prevState,
        receiptFiles: [],
        fileAlreadyUploaded: false,
      }));
      return;
    }
    const hasNewFiles = newFiles.some((file) => file instanceof File);
    setState((prevState) => ({
      ...prevState,
      receiptFiles: newFiles,
      fileAlreadyUploaded: hasNewFiles ? false : prevState.fileAlreadyUploaded,
    }));
  }, []);

  const handleOtherTextChange = (text) => {
    if (!currentStepData) return;

    setState((prevState) => ({
      ...prevState,
      otherOptionTexts: {
        ...prevState.otherOptionTexts,
        [currentStepData.id]: text,
      },
    }));
  };

  const handleOtherErrorChange = (hasError) => {
    setHasOtherError(hasError);
  };

  const saveCurrentAnswer = useCallback(
    async (showToast = true) => {
      if (!currentStepData) return;
      if (currentStepData.type === QuestionType.CHECKBOX) {
        const selectedCount = state.selectedOptions.length;
        const exactCount = currentStepData?.exactly_selection_quantity;
        const minCount = currentStepData?.minimum_selection_quantity;
        const maxCount = currentStepData?.maximum_selection_quantity;

        if (typeof exactCount === "number" && exactCount > 0) {
          if (selectedCount !== exactCount) {
            if (showToast) {
              toastUtils.error(
                t("toast.error.pleaseSelectExactlyOptions", {
                  count: exactCount,
                  selected: selectedCount,
                  type: "exactly",
                  toastId: "req-count-err",
                }) || `Please select exactly ${exactCount} options...`,
              );
            }
            throw new Error(
              `Validation failed: Need exactly ${exactCount} checkbox options`,
            );
          }
        } else {
          if (typeof minCount === "number" && minCount > 0) {
            if (selectedCount < minCount) {
              if (showToast) {
                toastUtils.error(
                  t("toast.error.pleaseSelectAtLeastOptions", {
                    count: minCount,
                    selected: selectedCount,
                    toastId: "req-count-err",
                  }),
                );
              }
              throw new Error(
                `Validation failed: Need at least ${minCount} checkbox options`,
              );
            }
          }

          if (typeof maxCount === "number" && maxCount > 0) {
            if (selectedCount > maxCount) {
              if (showToast) {
                toastUtils.error(
                  t("toast.error.pleaseSelectOnlyOptions", {
                    count: maxCount,
                    selected: selectedCount,
                    toastId: "req-count-err",
                  }),
                );
              }
              throw new Error(
                `Validation failed: Need at most ${maxCount} checkbox options`,
              );
            }
          }
        }
      }

      let isTextLengthInvalid = false;

      if (ANSWER_TEXT_TYPES.includes(currentStepData.type)) {
        if (state.answerText?.length > 0 && !mainAnswerValidation.isValid) {
          if (showToast) toastUtils.error(t("toast.error.thisQuestIsRequired"));
          throw new Error("Validation failed: Text length invalid");
        }
      }
      let effectiveMinRemark = 50;
      const minRem = currentStepData?.minimun_character_remarks;
      const maxRem = currentStepData?.maximun_character_remarks;

      if (typeof minRem === "number" && minRem > 0) {
        effectiveMinRemark = minRem;
      } else {
        if (typeof maxRem === "number" && maxRem > 0 && maxRem < 50) {
          effectiveMinRemark = 1;
        }
      }

      const isAnswerInvalid =
        isTextLengthInvalid ||
        (currentStepData.is_additional_comment &&
          currentStepData.is_required_additional_comment &&
          (state.additionalComment || "").trim().length < effectiveMinRemark);

      if (isAnswerInvalid) {
        if (showToast) {
          toastUtils.error(t("toast.error.thisQuestIsRequired"), {
            toastId: "validation-required",
          });
        }

        throw new Error("Validation failed: Answer invalid");
      }

      if (
        currentStepData?.is_required &&
        !isSelectedForRequiredQuest(
          currentStepData.type,
          state.selectedOption?.id,
          state.answerText,
        )
      ) {
        if (showToast) {
          toastUtils.error(t("toast.error.thisQuestIsRequired"), {
            toastId: "validation-required",
          });
        }
        throw new Error("Validation failed: Required question");
      }

      if (currentStepData.is_additional_comment) {
        if (!remarkValidation.isValid) {
          if (showToast) {
            // Nếu chưa nhập
            if (remarkValidation.length === 0) {
              toastUtils.error(
                t("quest.detailMultipleChoice.compulsoryReMarkRequired"),
              );
            } else {
              // Nếu nhập thiếu ký tự
              toastUtils.error(
                remarkValidation.errorMessage || "Remark invalid",
              );
            }
          }
          throw new Error("Validation failed: Remark invalid");
        }
      }

      if (hasOtherError) {
        throw new Error("Validation failed: Other option has an error");
      }

      // const selectedOptionData = currentStepData?.quest_question_option?.find(
      //   (option) => option.id === state.selectedOption?.id,
      // );
      // const isOtherOptionSelected = selectedOptionData?.is_other_option;
      const optionIds =
        currentStepData?.type === QuestionType.CHECKBOX
          ? state.selectedOptions.map((opt) => opt.id).filter(Boolean)
          : state.selectedOption?.id
            ? [state.selectedOption.id]
            : [];
      const hasOtherOptionSelected =
        currentStepData?.quest_question_option?.some(
          (option) => optionIds.includes(option.id) && option.is_other_option,
        );
      const body = {
        quest_question_id: currentStepData?.id,
        quest_question_option_id: state.selectedOption?.id || null,
        quest_question_option_ids: optionIds,
        quest_participant_id: id,
        answer_text: hasOtherOptionSelected
          ? state.otherOptionTexts[currentStepData.id] || ""
          : state.answerText || null,
        is_correct: state.selectedOption?.is_correct || false,
        additional_comment: state.additionalComment,
      };

      const response = await postAnswer(body).unwrap();
      return { response, savedAnswer: body };
    },
    [
      currentStepData,
      state.answerText,
      state.additionalComment,
      state.selectedOption,
      state.selectedOptions,
      state.otherOptionTexts,
      hasOtherError,
      id,
      postAnswer,
      t,
      mainAnswerValidation,
      remarkValidation,
    ],
  );

  const updateStateAfterSave = useCallback((savedAnswer) => {
    setState((prev) => ({
      ...prev,
      questAnswers: {
        ...prev.questAnswers,
        [savedAnswer.quest_question_id]: {
          quest_question_id: savedAnswer.quest_question_id,
          quest_question_option_id: savedAnswer.quest_question_option_id,
          quest_question_option_ids: savedAnswer.quest_question_option_ids,
          is_correct: savedAnswer.is_correct,
          additional_comment: savedAnswer.additional_comment,
          answer_text: savedAnswer.answer_text,
        },
      },
    }));
  }, []);

  const completeQuestFlow = useCallback(
    async (reviewData) => {
      if (!reviewData) {
        return;
      }

      setIsCompletingQuest(true);

      await new Promise((resolve) => setTimeout(resolve, 100));

      reviewCompleteRef.current?.closeModal();
      submitRef.current?.closeModal();

      try {
        const response = await postFileTakeQuestComplete({
          quest_id: id,
          xp: reviewData?.add_xp ?? 0,
          bonus_xp: reviewData?.bonus_xp ?? 0,
          token: reviewData?.add_token ?? "0",
          is_completed: reviewData?.is_completed ?? false,
        }).unwrap();

        if (response.message === "Creation successful") {
          localStorage.removeItem(`timer_${questId}`);
          localStorage.removeItem(`initialTime_${questId}`);
          try {
          } catch (err) {
            console.error("reviewData NOT cloneable:", err);
          }
          navigate(`/quest/details/completed`, {
            state: {
              responseAnswer: response,
              questReview: reviewData,
              slotLeft: questDetailsData?.data?.slot_available,
              questDetailsData: questDetailsData?.data,
            },
          });
          // modalRefs.completeReviewModal.current?.openModal();
        }
      } catch (err) {
        if (err.data?.detail[0].msg === "You already complete this quest") {
          toastUtils.warning(t("toast.warning.youAlreadyCompleteThisQuest"));
          navigate("/quest");
          localStorage.removeItem(`timer_${questId}`);
          localStorage.removeItem(`initialTime_${questId}`);
        } else {
          console.error("Failed to finalize quest:", err);
        }
      } finally {
        setIsCompletingQuest(false);
      }
    },
    [
      id,
      questId,
      navigate,
      postFileTakeQuestComplete,
      t,
      questDetailsData?.data,
    ],
  );

  const handleReview = useCallback(async () => {
    try {
      const { savedAnswer } = await saveCurrentAnswer();
      updateStateAfterSave(savedAnswer);
      setSubmittedSteps((prev) => {
        const stepIndex = state.currentStep - 1;
        return !prev.includes(stepIndex) ? [...prev, stepIndex] : prev;
      });
    } catch (error) {
      console.error("Validation/Save failed for the final answer:", error);
      return;
    }

    const unansweredQuestions = [];
    if (data?.data) {
      const stepOffset = isValidationReceipt ? 2 : 1;
      data?.data.forEach((question, index) => {
        if (state.currentStep - stepOffset === index) {
          return;
        }

        const stepNumberOfQuestion =
          state.questSteps[question.id] || index + stepOffset;
        const isSubmitted = submittedSteps.includes(stepNumberOfQuestion - 1);
        const hasStoredAnswer = !!state.questAnswers[question.id];

        if (!isSubmitted && !hasStoredAnswer) {
          unansweredQuestions.push({ questionNo: question.no });
        }
      });
    }

    if (unansweredQuestions.length > 0) {
      const questionNumbers = unansweredQuestions
        .map((q) => q.questionNo)
        .join(", ");
      toastUtils.error(
        `${t("toast.error.pleaseAnswerAllQuestions")} ${questionNumbers}`,
      );
      return;
    }

    // reviewingRef.current?.openModal();
    const isEditing = state.inErrorReviewMode || state.reviewMode;
    const activeModalRef = isEditing
      ? modalRefs.editQuestModal
      : modalRefs.reviewQuestModal;
    startProgress();
    activeModalRef.current?.openModal();
    try {
      const responseAnswer = await postQuestReview({
        participant_id: id,
      }).unwrap();
      await completeProgress();
      if (responseAnswer.status === 200) {
        setIsReviewingDataResponse(responseAnswer?.data);
        if (
          responseAnswer?.data?.add_token === 0 ||
          responseAnswer?.data?.add_xp === 0
        ) {
          setCongratulation(false);
        } else {
          setCongratulation(true);
        }
        const questErrors =
          responseAnswer?.data?.missing_or_not_correct_questions?.reduce(
            (acc, item) => {
              const defaultStep = isValidationReceipt ? 2 : 1;
              const stepIndex =
                state.questSteps[item.question_id] || defaultStep;
              acc[item.question_id] = { ...item, step_index: stepIndex };
              return acc;
            },
            {},
          );
        // setIsReviewingReceipt(responseAnswer?.data?.is_pass_review_receipt);
        setState((prevState) => ({ ...prevState, questErrors }));
        // reviewingRef.current?.closeModal();
        activeModalRef.current?.closeModal();

        const hasQuestErrors =
          questErrors && Object.keys(questErrors).length > 0;

        if (
          hasQuestErrors === false &&
          responseAnswer?.data?.is_pass_review_receipt === false
        ) {
          await completeQuestFlow(responseAnswer?.data);
          return;
        }

        if (
          isDeepDiveQuest &&
          hasQuestErrors === false &&
          responseAnswer?.data?.is_pass_review_receipt !== false
        ) {
          await completeQuestFlow(responseAnswer?.data);
          return;
        }

        if (responseAnswer?.data?.is_completed === true) {
          await completeQuestFlow(responseAnswer?.data);
          return;
        } else if (hasQuestErrors) {
          submitRef.current?.closeModal();
          reviewCompleteRef.current?.openModal();
        } else {
          // submitRef.current?.closeModal();
          // reviewCompleteRef.current?.openModal();
          await completeQuestFlow(responseAnswer?.data);
          return;
        }
      } else {
        toastUtils.error(t("toast.error.reviewFailed"));
        activeModalRef.current?.closeModal();
      }
    } catch (err) {
      resetProgress();
      activeModalRef.current?.closeModal();
      // toast.error(t("toast.error.reviewFailed"));
    }
  }, [
    data?.data,
    state.currentStep,
    state.inErrorReviewMode,
    state.reviewMode,
    submittedSteps,
    state.questAnswers,
    saveCurrentAnswer,
    id,
    postQuestReview,
    state.questSteps,
    t,
    updateStateAfterSave,
    completeQuestFlow,
    isDeepDiveQuest,
    modalRefs.reviewQuestModal,
    startProgress,
    completeProgress,
    resetProgress,
    modalRefs.editQuestModal,
    isValidationReceipt,
  ]);

  // const handleNextStep = useCallback(async () => {
  //   if (isNavigatingRef.current || isPostAnswering) return;

  //   isNavigatingRef.current = true;
  //   if (state.currentStep === 1 && isValidationReceipt) {
  //     setSubmittedSteps((prev) => (!prev.includes(0) ? [...prev, 0] : prev));
  //     setState((prevState) => ({
  //       ...prevState,
  //       currentStep: Math.min(prevState.currentStep + 1, totalSteps),
  //       fileAlreadyUploaded: true,
  //     }));
  //     return;
  //   }
  //   if (currentStepData && currentStepData.type === QuestionType.CHECKBOX) {
  //     const selectedCount = state.selectedOptions.length;
  //     // const requiredCount =
  //     //   currentStepData?.minimum_selection_quantity || state.maxCheckboxOptions;
  //     const requiredCount = currentStepData?.minimum_selection_quantity;
  //     if (
  //       requiredCount !== null &&
  //       requiredCount !== undefined &&
  //       requiredCount !== 0
  //     ) {
  //       if (selectedCount !== requiredCount) {
  //         if (selectedCount < requiredCount) {
  //           toast.error(
  //             t("toast.error.pleaseSelectExactlyOptions", {
  //               count: requiredCount,
  //               selected: selectedCount,
  //             }),
  //             { toastId: "checkbox-error" }
  //           );
  //         } else {
  //           toast.error(
  //             t("toast.error.pleaseSelectOnlyOptions", {
  //               count: requiredCount,
  //               selected: selectedCount,
  //             }),
  //             { toastId: "checkbox-error" }
  //           );
  //         }
  //         setTimeout(() => {
  //           isNavigatingRef.current = false;
  //         }, 500);
  //         return;
  //       }
  //     }
  //   }
  //   setIsPostAnswering(true);
  //   try {
  //     const { savedAnswer } = await saveCurrentAnswer();
  //     updateStateAfterSave(savedAnswer);

  //     setSubmittedSteps((prev) => {
  //       const stepIndex = state.currentStep - 1;
  //       return !prev.includes(stepIndex) ? [...prev, stepIndex] : prev;
  //     });

  //     if (state.reviewMode && state.errorStepsArray.length > 0) {
  //       const nextErrorStep = state.errorStepsArray.find(
  //         (step) => step > state.currentStep
  //       );

  //       if (nextErrorStep) {
  //         const nextErrorIndex = state.errorStepsArray.indexOf(nextErrorStep);
  //         setState((prev) => ({
  //           ...prev,
  //           currentStep: nextErrorStep,
  //           currentErrorStepIndex: nextErrorIndex,
  //           answerText: "",
  //           additionalComment: "",
  //           selectedOption: { id: null, is_correct: null },
  //           selectedOptions: [],
  //         }));
  //       } else {
  //         await handleReview();
  //       }
  //     } else if (state.currentStep >= totalSteps) {
  //       await handleReview();
  //     } else {
  //       setState((prev) => ({
  //         ...prev,
  //         currentStep: prev.currentStep + 1,
  //         answerText: "",
  //         additionalComment: "",
  //         selectedOption: { id: null, is_correct: null },
  //         selectedOptions: [],
  //       }));
  //     }

  //     setTimeout(() => window.scrollTo(0, 0), 10);
  //   } catch (error) {
  //     console.error("Error in handleNextStep:", error.message);
  //     setTimeout(() => {
  //       isNavigatingRef.current = false;
  //     }, 500);
  //   } finally {
  //     setIsPostAnswering(false);
  //     if (isNavigatingRef.current) {
  //       isNavigatingRef.current = false;
  //     }
  //   }
  // }, [
  //   isPostAnswering,
  //   state.currentStep,
  //   state.reviewMode,
  //   state.errorStepsArray,
  //   totalSteps,
  //   saveCurrentAnswer,
  //   handleReview,
  //   updateStateAfterSave,
  //   state.selectedOptions,
  //   t,
  //   currentStepData,
  //   isValidationReceipt,
  // ]);

  const handleNextStep = useCallback(async () => {
    if (isNavigatingRef.current || isPostAnswering) return;

    isNavigatingRef.current = true;

    try {
      if (state.currentStep === 1 && isValidationReceipt) {
        setSubmittedSteps((prev) => (!prev.includes(0) ? [...prev, 0] : prev));
        setState((prevState) => ({
          ...prevState,
          currentStep: Math.min(prevState.currentStep + 1, totalSteps),
          fileAlreadyUploaded: true,
        }));
        return;
      }

      if (currentStepData && currentStepData.type === QuestionType.CHECKBOX) {
        const selectedCount = state.selectedOptions.length;
        const exactCount = currentStepData?.exactly_selection_quantity;
        const minCount = currentStepData?.minimum_selection_quantity;
        const maxCount = currentStepData?.maximum_selection_quantity;

        if (typeof exactCount === "number" && exactCount > 0) {
          if (selectedCount !== exactCount) {
            toastUtils.error(
              t("toast.error.pleaseSelectExactlyOptions", {
                count: exactCount,
                selected: selectedCount,
              }) ||
                `Please select exactly ${exactCount} options. You have selected ${selectedCount}.`,
              { toastId: "checkbox-error" },
            );
            return;
          }
        } else {
          if (typeof minCount === "number" && minCount > 0) {
            if (selectedCount < minCount) {
              toastUtils.error(
                t("toast.error.pleaseSelectAtLeastOptions", {
                  count: minCount,
                  selected: selectedCount,
                }) ||
                  `Please select at least ${minCount} options. You have selected ${selectedCount}.`,
                { toastId: "checkbox-error" },
              );
              return;
            }
          }

          if (typeof maxCount === "number" && maxCount > 0) {
            if (selectedCount > maxCount) {
              toastUtils.error(
                t("toast.error.pleaseSelectOnlyOptions", {
                  count: maxCount,
                  selected: selectedCount,
                }) ||
                  `Please select at most ${maxCount} options. You have selected ${selectedCount}.`,
                { toastId: "checkbox-error" },
              );
              return;
            }
          }
        }
      }

      setIsPostAnswering(true);

      const { savedAnswer } = await saveCurrentAnswer();
      updateStateAfterSave(savedAnswer);

      setSubmittedSteps((prev) => {
        const stepIndex = state.currentStep - 1;
        return !prev.includes(stepIndex) ? [...prev, stepIndex] : prev;
      });

      if (state.reviewMode && state.errorStepsArray.length > 0) {
        const nextErrorStep = state.errorStepsArray.find(
          (step) => step > state.currentStep,
        );

        if (nextErrorStep) {
          const nextErrorIndex = state.errorStepsArray.indexOf(nextErrorStep);
          setState((prev) => ({
            ...prev,
            currentStep: nextErrorStep,
            currentErrorStepIndex: nextErrorIndex,
            answerText: "",
            additionalComment: "",
            selectedOption: { id: null, is_correct: null },
            selectedOptions: [],
          }));
        } else {
          await handleReview();
        }
      } else if (state.currentStep >= totalSteps) {
        await handleReview();
      } else {
        setState((prev) => ({
          ...prev,
          currentStep: prev.currentStep + 1,
          answerText: "",
          additionalComment: "",
          selectedOption: { id: null, is_correct: null },
          selectedOptions: [],
        }));
      }

      setTimeout(() => {
        if (contentRef.current) {
          contentRef.current.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 10);
    } catch (error) {
      console.error("Error in handleNextStep:", error.message);
    } finally {
      setIsPostAnswering(false);

      setTimeout(() => {
        isNavigatingRef.current = false;
      }, 500);
    }
  }, [
    isPostAnswering,
    state.currentStep,
    state.reviewMode,
    state.errorStepsArray,
    totalSteps,
    saveCurrentAnswer,
    handleReview,
    updateStateAfterSave,
    state.selectedOptions,
    t,
    currentStepData,
    isValidationReceipt,
  ]);

  // const handlePrevStep = useCallback(async () => {
  //   if (isPrevStepLoadingRef.current) return;
  //   isPrevStepLoadingRef.current = true;
  //   setIsPrevStepLoading(true);

  //   try {
  //     // Check and validate checkbox type questions
  //     if (currentStepData && currentStepData.type === QuestionType.CHECKBOX) {
  //       const selectedCount = state.selectedOptions.length;
  //       const requiredCount = currentStepData?.minimum_selection_quantity;
  //       if (
  //         requiredCount !== null &&
  //         requiredCount !== undefined &&
  //         requiredCount !== 0
  //       ) {
  //         if (selectedCount !== requiredCount) {
  //           if (selectedCount < requiredCount) {
  //             toast.error(
  //               t("toast.error.pleaseSelectExactlyOptions", {
  //                 count: requiredCount,
  //                 selected: selectedCount,
  //               })
  //             );
  //           } else {
  //             toast.error(
  //               t("toast.error.pleaseSelectOnlyOptions", {
  //                 count: requiredCount,
  //                 selected: selectedCount,
  //               })
  //             );
  //           }
  //           isPrevStepLoadingRef.current = false;
  //           setIsPrevStepLoading(false);
  //           return;
  //         }
  //       }
  //     }

  //     // Save current answer before navigating
  //     if (state.currentStep !== 1) {
  //       // Skip saving for step 1 as in handleNextStep
  //       const { savedAnswer } = await saveCurrentAnswer();
  //       updateStateAfterSave(savedAnswer);
  //       setSubmittedSteps((prev) => {
  //         const stepIndex = state.currentStep - 1;
  //         if (!prev.includes(stepIndex)) {
  //           return [...prev, stepIndex];
  //         }
  //         return prev;
  //       });
  //     }

  //     // Navigate to previous step
  //     if (state.reviewMode && state.errorStepsArray.length > 0) {
  //       const prevErrorIndex = state.currentErrorStepIndex - 1;
  //       if (prevErrorIndex >= 0) {
  //         setState((prev) => ({
  //           ...prev,
  //           currentErrorStepIndex: prevErrorIndex,
  //           currentStep: state.errorStepsArray[prevErrorIndex],
  //           answerText: "",
  //           additionalComment: "",
  //           selectedOption: { id: null, is_correct: null },
  //           selectedOptions: [],
  //         }));
  //       } else {
  //         const minStep = isValidationReceipt ? 2 : 1;
  //         const newStep = Math.max(state.currentStep - 1, minStep);
  //         setState((prev) => ({
  //           ...prev,
  //           currentStep: newStep,
  //           reviewMode: false,
  //           currentErrorStepIndex: 0,
  //           answerText: "",
  //           additionalComment: "",
  //           selectedOption: { id: null, is_correct: null },
  //           selectedOptions: [],
  //         }));
  //       }
  //     } else {
  //       const minStep = isValidationReceipt ? 2 : 1;
  //       const newStep = Math.max(state.currentStep - 1, minStep);
  //       setState((prev) => ({
  //         ...prev,
  //         currentStep: newStep,
  //         isFromReview: false,
  //         answerText: "",
  //         additionalComment: "",
  //         selectedOption: { id: null, is_correct: null },
  //         selectedOptions: [],
  //       }));
  //     }

  //     setTimeout(() => {
  //       const contentContainer = document.querySelector(
  //         ".flex-1.overflow-y-auto"
  //       );
  //       if (contentContainer) {
  //         contentContainer.scrollTop = 0;
  //       }
  //       window.scrollTo(0, 0);
  //     }, 10);
  //   } catch (error) {
  //     console.error("Error in handlePrevStep:", error);
  //   } finally {
  //     setTimeout(() => {
  //       isPrevStepLoadingRef.current = false;
  //       setIsPrevStepLoading(false);
  //     }, 500);
  //   }
  // }, [
  //   state.reviewMode,
  //   state.errorStepsArray,
  //   state.currentErrorStepIndex,
  //   state.currentStep,
  //   state.selectedOptions,
  //   currentStepData,
  //   t,
  //   saveCurrentAnswer,
  //   updateStateAfterSave,
  //   isValidationReceipt,
  // ]);
  const handlePrevStep = useCallback(async () => {
    if (isPrevStepLoadingRef.current) return;
    isPrevStepLoadingRef.current = true;
    setIsPrevStepLoading(true);

    try {
      // if (state.currentStep !== 1) {
      //   const { savedAnswer } = await saveCurrentAnswer();
      //   updateStateAfterSave(savedAnswer);
      // }
      if (state.currentStep !== 1) {
        try {
          const { savedAnswer } = await saveCurrentAnswer(false);
          updateStateAfterSave(savedAnswer);
        } catch (saveError) {
          console.warn(
            "Validation failed on previous step, skipping save:",
            saveError,
          );
        }
      }

      if (state.reviewMode && state.errorStepsArray.length > 0) {
        const reversedErrors = [...state.errorStepsArray].reverse();
        const prevErrorStep = reversedErrors.find(
          (step) => step < state.currentStep,
        );

        if (prevErrorStep) {
          const prevErrorIndex = state.errorStepsArray.indexOf(prevErrorStep);
          setState((prev) => ({
            ...prev,
            currentStep: prevErrorStep,
            currentErrorStepIndex: prevErrorIndex,
            answerText: "",
            additionalComment: "",
            selectedOption: { id: null },
            selectedOptions: [],
          }));
        } else {
        }
      } else {
        const minStep = 1;
        const newStep = Math.max(state.currentStep - 1, minStep);

        setState((prev) => ({
          ...prev,
          currentStep: newStep,
          answerText: "",
          additionalComment: "",
          selectedOption: { id: null },
          selectedOptions: [],
        }));
      }

      setTimeout(() => window.scrollTo(0, 0), 10);
    } catch (error) {
      console.error("Error prev:", error);
    } finally {
      setTimeout(() => {
        isPrevStepLoadingRef.current = false;
        setIsPrevStepLoading(false);
      }, 500);
    }
  }, [
    state.reviewMode,
    state.errorStepsArray,
    state.currentStep,
    saveCurrentAnswer,
    updateStateAfterSave,
  ]);

  const handleComplete = useCallback(
    async (reviewDataParam) => {
      if (
        isValidationReceipt &&
        (state.receiptFiles.length === 0 || state.currentStep === 1)
      ) {
        toastUtils.error(
          t("toast.error.pleaseUploadAtLeastOneFileInStep1BeforeSubmitting"),
        );
        setState((prev) => ({
          ...prev,
          currentStep: 1,
          isFromReview: true,
        }));
        return;
      }

      const reviewData = reviewDataParam ?? isReviewingDataResponse;
      if (!reviewData) {
        return;
      }

      await completeQuestFlow(reviewData);
    },
    [
      completeQuestFlow,
      isReviewingDataResponse,
      isValidationReceipt,
      state.currentStep,
      state.receiptFiles,
      t,
    ],
  );

  const handlePauseTakeQuest = useCallback(async () => {
    try {
      const minutesLeft = state.time / 60;

      await postPauseTimerParticipant({
        participant_id: id,
        minutes_left: minutesLeft,
      }).unwrap();

      navigate(`/quest/location/${locationId}`);

      dispatch(
        apiSlice.util.invalidateTags([
          { type: "QuestDetails", id: `Detail_${questId}` },
        ]),
      );
    } catch (error) {
      console.error("Failed to pause quest:", error);
      toastUtils.error(t("toast.error.failedToPauseQuest"));
    }
  }, [
    navigate,
    locationId,
    dispatch,
    state.time,
    id,
    postPauseTimerParticipant,
    t,
    questId,
  ]);

  const handleEndQuest = useCallback(async () => {
    try {
      const response = await postEndQuest({
        participant_id: id,
      }).unwrap();
      if (
        response.message === "Creation successful" ||
        response.status === 200
      ) {
        localStorage.removeItem(`timer_${questId}`);
        localStorage.removeItem(`initialTime_${questId}`);
        dispatch(
          apiSlice.util.invalidateTags([
            "QuestList",
            { type: "QuestDetails", id: `Detail_${questId}` },
          ]),
        );
        toastUtils.success(response?.data.message);
        navigate(`/quest/location/${locationId}`);
      }
    } catch (error) {
      console.error("Failed to end quest:", error);
      toastUtils.error("Failed to end quest");
    }
  }, [id, questId, navigate, postEndQuest, dispatch, locationId]);

  const handleSaveQuest = useCallback(async () => {
    try {
      const response = await postSaveQuest({
        participant_id: id,
      }).unwrap();

      if (response.status === HttpStatusCode.UnprocessableEntity) {
        try {
          const response = await postEndQuest({
            participant_id: id,
          }).unwrap();
          if (
            response.message === "Creation successful" ||
            response.status === 200
          ) {
            localStorage.removeItem(`timer_${questId}`);
            localStorage.removeItem(`initialTime_${questId}`);
            dispatch(
              apiSlice.util.invalidateTags([
                "QuestList",
                {
                  type: "QuestDetails",
                  id: `Detail_${questId}`,
                },
              ]),
            );
            toastUtils.success(response?.data.message);
            navigate(`/quest/location/${locationId}`);
          }
        } catch (error) {
          console.error("Failed to end quest:", error);
        }
      } else if (
        response.message === "Creation successful" ||
        response.status === 200
      ) {
        localStorage.removeItem(`timer_${questId}`);
        localStorage.removeItem(`initialTime_${questId}`);
        navigate(`/quest/location/${locationId}`);
      }
    } catch (error) {
      console.error("Failed to save quest:", error);
    }
  }, [
    id,
    navigate,
    postSaveQuest,
    dispatch,
    postEndQuest,
    questId,
    locationId,
  ]);

  const handleBackQuest = useCallback(() => {
    if (
      isReviewingDataResponse?.ocr_receipt_job === false ||
      isReviewingDataResponse?.is_location === false ||
      isReviewingDataResponse?.is_time === false
    ) {
      setState((prev) => ({
        ...prev,
        currentStep: isValidationReceipt ? 1 : 2,
      }));
      modalRefs.reviewComplete.current?.closeModal();
      return;
    }

    const errorQuestions = Object.values(state.questErrors);
    if (errorQuestions.length === 0) {
      toastUtils.error(t("toast.error.noErrorsToReview"));
      modalRefs.reviewComplete.current?.closeModal();
      return;
    }

    const errorStepsArray = Object.values(state.questErrors || {})
      .map((error) => error.step_index)
      .filter((step) => typeof step === "number" && !isNaN(step))
      .sort((a, b) => a - b);
    const sortedErrors = errorQuestions.sort(
      (a, b) => (a.no || 0) - (b.no || 0),
    );

    setSubmittedSteps([]);

    setState((prev) => ({
      ...prev,
      inErrorReviewMode: true,
      currentErrorIndex: 0,
      errorQuestionsList: sortedErrors,
      reviewMode: true,
      errorStepsArray,
      currentErrorStepIndex: 0,
      currentStep:
        errorStepsArray.length > 0 ? errorStepsArray[0] : prev.currentStep,
    }));

    modalRefs.reviewComplete.current?.closeModal();
  }, [
    isReviewingDataResponse,
    state.questErrors,
    t,
    modalRefs,
    isValidationReceipt,
  ]);

  const sortedOptions = useCallback((options = []) => {
    const otherOptions = [];
    const normalOptions = [];

    options.forEach((option) => {
      const text = String(option.option_text || "").toLowerCase();

      if (text === "other" || text === "others" || option.is_other_option) {
        otherOptions.push(option);
      } else {
        normalOptions.push(option);
      }
    });

    normalOptions.sort((a, b) => {
      const valueA = Number(a.value) || 0;
      const valueB = Number(b.value) || 0;
      return valueA - valueB;
    });

    otherOptions.sort((a, b) => {
      const valueA = Number(a.value) || 999;
      const valueB = Number(b.value) || 999;
      return valueA - valueB;
    });

    return [...normalOptions, ...otherOptions];
  }, []);

  // const handleStepChange = useCallback(
  //   async (newStep, options = {}) => {
  //     if (options.skipValidation) {
  //       setState((prev) => ({
  //         ...prev,
  //         currentStep: newStep + 1,
  //       }));
  //       return;
  //     }

  //     // const hasStoredAnswer = currentStepData?.id
  //     //   ? !!state.questAnswers[currentStepData.id]
  //     //   : false;

  //     const hasCurrentInput =
  //       (state.selectedOption?.id && state.selectedOption.id !== null) ||
  //       (state.selectedOptions && state.selectedOptions.length > 0) ||
  //       (state.answerText && state.answerText.trim()) ||
  //       (state.additionalComment && state.additionalComment.trim()) ||
  //       (currentStepData?.id &&
  //         state.otherOptionTexts[currentStepData.id] &&
  //         state.otherOptionTexts[currentStepData.id].trim());

  //     if (currentStepData && currentStepData.type === QuestionType.CHECKBOX) {
  //       const selectedCount = state.selectedOptions.length;
  //       // const requiredCount =
  //       //   currentStepData?.minimum_selection_quantity || state.maxCheckboxOptions;
  //       const requiredCount = currentStepData?.minimum_selection_quantity;
  //       if (
  //         requiredCount !== null &&
  //         requiredCount !== undefined &&
  //         requiredCount !== 0
  //       ) {
  //         if (selectedCount !== requiredCount) {
  //           if (selectedCount < requiredCount) {
  //             toast.error(
  //               t("toast.error.pleaseSelectExactlyOptions", {
  //                 count: requiredCount,
  //                 selected: selectedCount,
  //               })
  //             );
  //           } else {
  //             toast.error(
  //               t("toast.error.pleaseSelectOnlyOptions", {
  //                 count: requiredCount,
  //                 selected: selectedCount,
  //               })
  //             );
  //           }
  //           return;
  //         }
  //       }
  //     }
  //     if (hasCurrentInput === undefined) {
  //       toast.error(t("toast.error.thisQuestIsRequired"));
  //       return;
  //     }
  //     if (
  //       !(state.currentStep === 1 && isValidationReceipt) &&
  //       hasCurrentInput &&
  //       !isPostAnswering
  //     ) {
  //       setIsPostAnswering(true);
  //       try {
  //         const { savedAnswer } = await saveCurrentAnswer();
  //         updateStateAfterSave(savedAnswer);
  //         setSubmittedSteps((prev) => {
  //           const stepIndex = state.currentStep - 1;
  //           return !prev.includes(stepIndex) ? [...prev, stepIndex] : prev;
  //         });
  //       } catch (error) {
  //         console.error("Error saving answer in handleStepChange:", error);
  //         return;
  //         // if (!error.message.includes("Validation failed")) {
  //         //   setIsPostAnswering(false);
  //         //   return;
  //         // }
  //       } finally {
  //         setIsPostAnswering(false);
  //       }
  //     }

  //     setState((prev) => ({
  //       ...prev,
  //       currentStep: newStep + 1,
  //       isFromReview: false,
  //     }));

  //     setTimeout(() => {
  //       const contentContainer = document.querySelector(
  //         ".flex-1.overflow-y-auto"
  //       );
  //       if (contentContainer) {
  //         contentContainer.scrollTop = 0;
  //       }
  //       window.scrollTo(0, 0);
  //     }, 10);
  //   },
  //   [
  //     currentStepData,
  //     state.selectedOption,
  //     state.selectedOptions,
  //     state.answerText,
  //     state.additionalComment,
  //     state.otherOptionTexts,
  //     isPostAnswering,
  //     saveCurrentAnswer,
  //     updateStateAfterSave,
  //     state.currentStep,
  //     t,
  //     isValidationReceipt,
  //   ]
  // );

  const checkCurrentStepValid = useCallback(() => {
    if (!currentStepData) return false;

    // 1. Validate Checkbox (Số lượng chọn)
    if (currentStepData.type === QuestionType.CHECKBOX) {
      const selectedCount = state.selectedOptions.length;
      const exactCount = currentStepData?.exactly_selection_quantity;
      const minCount = currentStepData?.minimum_selection_quantity;
      const maxCount = currentStepData?.maximum_selection_quantity;

      if (typeof exactCount === "number" && exactCount > 0) {
        if (selectedCount !== exactCount) return false;
      } else {
        if (typeof minCount === "number" && minCount > 0) {
          if (selectedCount < minCount) return false;
        }
        if (typeof maxCount === "number" && maxCount > 0) {
          if (selectedCount > maxCount) return false;
        }
      }
      if (currentStepData.is_required && selectedCount === 0) return false;
    }

    if (ANSWER_TEXT_TYPES.includes(currentStepData.type)) {
      if (mainAnswerValidation.length === 0 && currentStepData.is_required)
        return false;
      if (mainAnswerValidation.length > 0 && !mainAnswerValidation.isValid)
        return false;
    }
    if (
      currentStepData.is_additional_comment &&
      currentStepData.is_required_additional_comment
    ) {
      if (!remarkValidation.isValid) return false;
    }

    // 4. Validate Required General (Radio/MCQ selection)
    if (
      currentStepData?.is_required &&
      !isSelectedForRequiredQuest(
        currentStepData.type,
        state.selectedOption?.id,
        state.answerText,
      )
    ) {
      return false;
    }

    // 5. Validate Other Option (Nếu chọn Other thì phải nhập text)
    const selectedOptionData = currentStepData?.quest_question_option?.find(
      (option) => option.id === state.selectedOption?.id,
    );
    if (selectedOptionData?.is_other_option) {
      const otherText = state.otherOptionTexts[currentStepData.id] || "";
      if (!otherText.trim()) return false;
    }

    // 6. Check lỗi Other (nếu có state lỗi từ component con)
    if (hasOtherError) return false;

    return true;
  }, [
    currentStepData,
    state,
    hasOtherError,
    mainAnswerValidation,
    remarkValidation,
  ]);

  const handleDropReportClick = useCallback(async () => {
    try {
      const minutesLeft = state.time / 60;

      await postPauseTimerParticipant({
        participant_id: id,
        minutes_left: minutesLeft,
      }).unwrap();

      dispatch(
        apiSlice.util.invalidateTags([
          { type: "QuestDetails", id: `Detail_${questId}` },
        ]),
      );

      navigate("/profile/support/contactUS");
    } catch (error) {
      console.error("Failed to pause quest before report:", error);
      toastUtils.error(t("toast.error.failedToPauseQuest"));

      navigate("/profile/support/contactUS");
    }
  }, [
    state.time,
    id,
    postPauseTimerParticipant,
    dispatch,
    questId,
    navigate,
    t,
  ]);

  const renderQuestionContent = () => {
    if (questType === "REFERRAL") {
      return (
        <div className="flex flex-col mt-[49px] w-full  gap-[18px]">
          <h1 className="text-[#253FF6] text-2xl font-bold">
            {t("referral.title") || "Referral"}
          </h1>
          {/* Recipient Name Input */}
          <label className="text-[#A0A0A0] text-base font-normal">
            {t("referral.yourDisplayName") || "Your display name"}
          </label>
          <input
            type="text"
            value={referralDisplayName}
            onChange={(e) => setReferralDisplayName(e.target.value)}
            className="w-full h-[50px] rounded-md border border-stone-200 focus:outline-none focus:border-[#A0A0A0] px-4 text-black font-medium transition-colors duration-200"
          />
          <label className="text-[#A0A0A0] text-base font-normal">
            {t("referral.recipientName") || "Recipient's name"}
          </label>
          <input
            type="text"
            value={referralName}
            onChange={(e) => setReferralName(e.target.value)}
            className="w-full h-[50px] rounded-md border border-stone-200 focus:outline-none focus:border-[#A0A0A0] px-4 text-black font-medium transition-colors duration-200"
          />
          <label className="text-[#A0A0A0] text-base font-normal">
            {t("referral.recipientNumber") || "Recipient's number"}
          </label>
          <div className="w-full flex flex-col gap-6">
            <CustomInputProps
              value={referralPhoneNumber}
              placeholder={t("signUp.whatsAppNumber")}
              onChange={(value) =>
                setReferralPhoneNumber(formatedPhoneNumber(value))
              }
              countryCode={"+65"}
              showIcon={false}
            />
          </div>

          {/* Referral Message Input */}
          <label className="text-[#A0A0A0] text-base font-normal mt-2">
            {t("referral.referralMessage") || "Referral message"}
          </label>
          <textarea
            value={referralMessage}
            onChange={(e) => setReferralMessage(e.target.value)}
            className="w-full min-h-[150px] rounded-md border border-stone-200 focus:outline-none focus:border-[#A0A0A0] px-4 py-3 text-[#A0A0A0] text-base resize-none transition-colors duration-200 leading-relaxed"
            placeholder={t("referral.enterMessage") || "Enter your message"}
          />

          {/* Share Button */}
          <Button
            className="w-full rounded-md bg-[#253FF6] text-[20px] text-white font-medium flex items-center justify-center gap-2 py-3 px-[18px] mt-0"
            onClick={handleReferralShare}
            disabled={isCreatingCode}
            text={t("referral.shareButton")}
            iconMoon={<span className="icon icon-share text-white text-lg" />}
          />
        </div>
      );
    }
    if (state.currentStep === 1 && isValidationReceipt) {
      return (
        <div className="flex flex-col mt-[49px] w-full gap-[18px]">
          <h4 className="text-2xl font-bold leading-tight text-[#253FF6]">
            {t("quest.detailMultipleChoice.uploadReceipt")}
          </h4>
          <span className="text-base font-normal leading-tight text-[#A0A0A0] ">
            {" "}
            {renderWithBold(
              t("quest.detailMultipleChoice.uploadOfficialReceipt"),
            )}
          </span>
          <div>
            <UploadComponent
              label={t("base.upload")}
              onFileUpload={handleFileUpload}
              maxFiles={1}
              participantId={id}
              initialFiles={state.receiptFiles}
              handleNextStep={handleNextStep}
              setFileUploaded={(value) =>
                setState((prev) => ({
                  ...prev,
                  fileAlreadyUploaded: value,
                }))
              }
            />
          </div>
        </div>
      );
    }

    if (isLoading || isQuestLoading || !currentStepData) {
      return (
        <div className="flex flex-col items-center justify-center mt-12 w-full">
          <BeatLoader size={10} color="#253FF6" />
          <span className="mt-4 text-base text-[#A0A0A0]">
            {t("base.loading")}
          </span>
        </div>
      );
    }
    const selectedValue = currentStepData?.quest_question_option?.find(
      (item) => item.id === state.selectedOption?.id,
    )?.value;

    return (
      <div className="flex flex-col mt-[49px] w-full gap-[18px]">
        <QuestionCard
          dataEditAble={currentStepData}
          text={currentStepData.question}
          stt={currentStepData.no}
          typeQuestion={currentStepData.type}
          requiredOption={currentStepData.minimum_selection_quantity}
          questReviewErrors={state.questErrors[currentStepData.id]}
        />
        <div className="flex flex-col flex-1 justify-between w-full pb-6 gap-[18px] ">
          {ANSWER_YESNO_TYPES.includes(currentStepData.type) && (
            <div className="flex flex-col flex-1 gap-[18px]">
              {sortedOptions(currentStepData.quest_question_option).map(
                (option, index) => {
                  const isOptionSelected =
                    currentStepData.type === QuestionType.CHECKBOX
                      ? state.selectedOptions.some(
                          (opt) => opt.id === option.id,
                        )
                      : state.selectedOption.id === option.id;

                  return (
                    <AnswerYesNoQuestion
                      key={option.id}
                      letter={index + 1}
                      text={option.option_text}
                      isSelected={isOptionSelected}
                      hasOtherOption={currentStepData?.has_other_option}
                      isOtherOption={option?.is_other_option}
                      onClick={() => handleSelect(option.id, option.is_correct)}
                      onOtherErrorChange={handleOtherErrorChange}
                      onOtherTextChange={handleOtherTextChange}
                      otherText={
                        isOptionSelected && option?.is_other_option
                          ? state.otherOptionTexts[currentStepData.id] || ""
                          : ""
                      }
                      isCheckbox={
                        currentStepData.type === QuestionType.CHECKBOX
                      }
                    />
                  );
                },
              )}
            </div>
          )}
          {ANSWER_OPTION_TYPES.includes(currentStepData.type) && (
            <div className="flex flex-col flex-1 gap-[18px]">
              {sortedOptions(currentStepData.quest_question_option).map(
                (option, index) => {
                  const isOptionSelected =
                    currentStepData.type === QuestionType.CHECKBOX
                      ? state.selectedOptions.some(
                          (opt) => opt.id === option.id,
                        )
                      : state.selectedOption.id === option.id;

                  return (
                    <AnswerOption
                      key={option.id}
                      letter={index + 1}
                      text={option.option_text}
                      isSelected={isOptionSelected}
                      hasOtherOption={currentStepData?.has_other_option}
                      isOtherOption={option?.is_other_option}
                      onClick={() => handleSelect(option.id, option.is_correct)}
                      onOtherErrorChange={handleOtherErrorChange}
                      onOtherTextChange={handleOtherTextChange}
                      otherText={
                        isOptionSelected && option?.is_other_option
                          ? state.otherOptionTexts[currentStepData.id] || ""
                          : ""
                      }
                      isCheckbox={
                        currentStepData.type === QuestionType.CHECKBOX
                      }
                    />
                  );
                },
              )}
            </div>
          )}
          {state.questErrors &&
          currentStepData?.id &&
          state.questErrors[currentStepData.id] &&
          ["long", "short"].includes(currentStepData.type) ? (
            <div className="flex flex-col items-start rounded-lg bg-[#F5E3E6] p-3">
              <div className="flex items-center">
                <span className="text-base text-[#EF4056] font-bold">
                  {t("quest.detailMultipleChoice.tip")}:
                </span>
              </div>
              <div className="w-full text-base text-[#EF4056] font-medium">
                {state.questErrors[currentStepData.id].hint}
              </div>
            </div>
          ) : null}

          {ANSWER_TEXT_TYPES.includes(currentStepData.type) && (
            <div className="flex flex-col gap-[18px]">
              {currentStepData.type === "long" ? (
                <textarea
                  value={state.answerText || ""}
                  onChange={(e) =>
                    handleAnswerChange("answerText", e.target.value)
                  }
                  maxLength={mainAnswerValidation.max || undefined}
                  className={cn(
                    "min-h-[150px] rounded-md border border-solid focus-visible:outline-none p-3 resize transition-colors duration-200",

                    state.questErrors[currentStepData.id] &&
                      !state.questErrors[currentStepData.id]?.hideBorder &&
                      (state.answerText || "").length > 0
                      ? "border-[#EF4056] text-[#EF4056]"
                      : "border-stone-200 text-[#333]",
                  )}
                  placeholder={t("quest.detailMultipleChoice.yourLongAnswer")}
                />
              ) : (
                <input
                  value={state.answerText || ""}
                  onChange={(e) =>
                    handleAnswerChange("answerText", e.target.value)
                  }
                  maxLength={mainAnswerValidation.max || undefined}
                  className={cn(
                    "h-[50px] rounded-md border border-solid focus-visible:outline-none p-3 transition-colors duration-200",
                    state.questErrors[currentStepData.id] &&
                      !state.questErrors[currentStepData.id]?.hideBorder &&
                      (state.answerText || "").length > 0
                      ? "border-[#EF4056] text-[#EF4056]"
                      : "border-stone-200 text-[#333]",
                  )}
                  placeholder={t("quest.detailMultipleChoice.yourShortAnswer")}
                />
              )}

              {mainAnswerValidation.length > 0 &&
                !mainAnswerValidation.isValid && (
                  <div className="text-sm text-red-500 mt-1">
                    {mainAnswerValidation.errorMessage}
                  </div>
                )}

              {renderCounter(mainAnswerValidation)}
            </div>
          )}
          {ANSWER_SLIDER_TYPES.includes(currentStepData.type) &&
            (() => {
              const sortedOptions = [
                ...(currentStepData.quest_question_option || []),
              ].sort((a, b) => Number(a.value) - Number(b.value));
              const min = 1;
              const max = sortedOptions.length;
              const selectedItem = selectedValue
                ? sortedOptions.find(
                    (item) => Number(item.value) === Number(selectedValue),
                  )
                : null;

              return (
                <div className="flex flex-col gap-[14px]">
                  {!selectedValue && (
                    <div className="text-sm text-[#EF4056] flex justify-start items-end">
                      {t(
                        "quest.detailMultipleChoice.pleaseSlideToYourPreference",
                      )}
                    </div>
                  )}

                  <div className="text-base font-medium leading-tight text-[#A0A0A0]">
                    {min} - {sortedOptions[0]?.option_text}
                    <br />
                    {max} -{" "}
                    {sortedOptions[sortedOptions.length - 1]?.option_text}
                  </div>
                  <TextScroll selectedItem={selectedItem} />
                  <Slider
                    min={min}
                    max={max}
                    step={1}
                    value={selectedValue ? [Number(selectedValue)] : [min]}
                    onValueChange={(value) => {
                      const selectedValue = Math.ceil(value[0]);
                      const selectedItem = sortedOptions.find(
                        (item) => Number(item.value) === selectedValue,
                      );
                      if (selectedItem) {
                        handleSelect(selectedItem.id, selectedItem.is_correct);
                      }
                    }}
                  />
                </div>
              );
            })()}

          {currentStepData.is_additional_comment && (
            <div className="flex flex-col gap-[18px]">
              <div className="text-xl mt-[18px] font-medium flex items-center gap-1">
                {currentStepData?.remarks_title
                  ? currentStepData?.remarks_title
                  : t("base.remarks")}
                {currentStepData?.is_required_additional_comment ? (
                  <div>
                    <span>({t("base.required")})</span>
                    <span className="text-destructive ml-1">*</span>
                  </div>
                ) : (
                  <div>
                    <span>({t("base.optional")})</span>
                  </div>
                )}
              </div>

              {state.questErrors &&
              currentStepData?.id &&
              state.questErrors[currentStepData.id] &&
              !["long", "short"].includes(currentStepData.type) ? (
                <div className="flex flex-col items-start rounded-lg bg-[#F5E3E6] p-3">
                  <div className="flex items-center">
                    <span className="text-base text-[#EF4056] font-bold">
                      {t("quest.detailMultipleChoice.tip")}:
                    </span>
                  </div>
                  <div className="w-full text-base text-[#EF4056] font-medium">
                    {state.questErrors[currentStepData.id].hint}
                  </div>
                </div>
              ) : null}

              <textarea
                value={state.additionalComment || ""}
                maxLength={remarkValidation.max || undefined}
                onChange={(e) =>
                  handleAnswerChange("additionalComment", e.target.value)
                }
                className={cn(
                  "min-h-[150px] rounded-md border border-solid focus-visible:outline-none p-3 w-full transition-colors duration-200",

                  state.questErrors[currentStepData.id] &&
                    !state.questErrors[currentStepData.id]?.hideBorder &&
                    (state.additionalComment || "").length > 0
                    ? "border-[#EF4056] text-[#EF4056]"
                    : "border-stone-200",
                )}
                placeholder={
                  currentStepData.additional_comment_placeholder || ""
                }
              />

              {currentStepData.is_required_additional_comment &&
                remarkValidation.length > 0 &&
                !remarkValidation.isValid && (
                  <div className="text-sm text-red-500">
                    {remarkValidation.errorMessage}
                  </div>
                )}

              {/* Counter Remark - Tái sử dụng hàm render */}
              {currentStepData.is_required_additional_comment &&
                renderCounter(remarkValidation)}
            </div>
          )}
        </div>
      </div>
    );
  };
  const handleExtendTime = async () => {
    if (!id) {
      toastUtils.error(t("toast.error.invalidParticipantId"));
      return;
    }
    try {
      const response = await triggerTimeExtension({
        quest_participants_id: id,
      }).unwrap();

      if (response.status === 200) {
        const questResponse = await getDetailsPractice({
          participant_id: id,
        }).unwrap();
        if (questResponse.status === 200) {
          setExpiredAtTime(questResponse.data.expired_at || null);
          setQuotaType(questResponse.data?.quota_type ?? "SLOT");
          // const selectedItem = questResponse.data.find(
          //   (item) => String(item.id) === String(id)
          // );

          // if (selectedItem) {
          //   setExpiredAtTime(selectedItem.expired_at || null);
          //   setQuotaType(
          //     selectedItem?.quest?.quest_business?.quota_type ?? "SLOT"
          //   );
          // } else {
          //   console.warn("No matching item found for ID:", id);
          //   setExpiredAtTime(null);
          // }
        }
        timeIsRunningRef.current?.closeModal();
        toastUtils.success(t("toast.success.timeExtensionSuccess"));
      }
    } catch (err) {
      console.error("Failed to extend time:", err);
      if (err.status === 422) {
        toastUtils.error(err.data.detail[0].msg);
        setState((prev) => ({
          ...prev,
          checkRunningTime: true,
        }));
        timeIsRunningRef.current.closeModal();
        toastUtils.error(t("toast.error.timeExtensionFailed"));
      } else {
        setState((prev) => ({
          ...prev,
          checkRunningTime: true,
        }));
        timeIsRunningRef.current.closeModal();
      }
    }
  };

  const renderNextButton = () => {
    const isLastErrorStep =
      state.reviewMode &&
      state.errorStepsArray.length > 0 &&
      state.currentErrorStepIndex === state.errorStepsArray.length - 1;

    const isLastStep = state.currentStep >= totalSteps;
    const isValid = checkCurrentStepValid();
    const isErrorState = !!state.questErrors[currentStepData?.id];

    const activeColor = isErrorState
      ? "text-[#253FF6]"
      : isValid
        ? "text-[#253FF6]"
        : "text-[#E9E6E4]";

    return (
      <div className="flex flex-col justify-center items-center w-[100px]">
        {isLastErrorStep || isLastStep ? (
          <>
            <span
              className={cn(
                "text-sm font-bold whitespace-nowrap",
                "transition-colors duration-300 ease-in-out",
                isValid ? "text-[#253FF6]" : "text-[#E9E6E4]",
              )}
            >
              {t("base.review")}
            </span>
            <button
              className={cn(
                "mt-1",
                "transition-all duration-300 ease-in-out",
                isPostAnswering && "opacity-50 cursor-not-allowed ",
              )}
              onClick={() => isValid && handleReview()}
              disabled={!isValid || isPostAnswering}
            >
              <span
                className={cn(
                  "icon icon-arrow-right text-[18px]",
                  "transition-colors duration-300 ease-in-out",
                  // isValid ? "text-[#253FF6]" : "text-[#E9E6E4]"
                  activeColor,
                )}
              />
            </button>
          </>
        ) : (
          <>
            <span className="text-center text-[#253FF6] font-[Figtree] text-[14px] font-bold">
              {t("base.next")}
            </span>
            <button
              className={cn(
                "w-full flex items-end justify-center",
                isPostAnswering && "opacity-50 cursor-not-allowed",
              )}
              onClick={() => isValid && handleNextStep()}
              disabled={!isValid || isPostAnswering}
            >
              <span
                className={cn(
                  "icon icon-arrow-right text-[18px]",
                  "transition-colors duration-300 ease-in-out",
                  // isValid ? "text-[#253FF6]" : "text-[#E9E6E4]"
                  activeColor,
                )}
              />
            </button>
          </>
        )}
      </div>
    );
  };

  const renderPrevButton = () => {
    const isDisabled =
      isPrevStepLoading ||
      (!state.reviewMode && state.currentStep <= (isValidationReceipt ? 2 : 1));

    // const isHidden = state.currentStep === 2 && isValidationReceipt;

    const shouldHidePrev =
      !state.reviewMode &&
      (isValidationReceipt ? state.currentStep <= 2 : state.currentStep <= 1);

    return (
      <div
        className={cn(
          "flex flex-col justify-end items-center w-[100px]",
          shouldHidePrev && "invisible",
        )}
      >
        <span
          className={cn(
            "text-center text-[#253FF6] font-[Figtree] text-[14px] font-bold mb-1",
            isDisabled && "cursor-not-allowed ",
          )}
        >
          {t("base.previous")}
        </span>
        <button
          className={cn(
            "flex items-center justify-center",
            "transition-all duration-300 ease-in-out",
            isPrevStepLoading
              ? "opacity-100 visible cursor-not-allowed"
              : isDisabled
                ? "pointer-events-none"
                : "opacity-100 visible",
          )}
          onClick={() => handlePrevStep()}
          disabled={isDisabled}
        >
          <span
            className={cn("icon icon-arrow-left text-[18px] text-[#253FF6]")}
          />
        </button>
      </div>
    );
  };

  return (
    <div className="flex flex-col w-full max-w-[480px]  bg-[#FFFFFF] h-screen">
      <LoadingCommon statusLoading={isTimeRunningLoading || isPostAnswering} />
      {isCompletingQuest && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            zIndex: 10000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="flex flex-col items-center gap-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#253FF6]"></div>
            <span className="text-lg font-medium text-[#253FF6]">
              {"Processing..."}
            </span>
          </div>
        </div>
      )}
      <HeaderQuestPratice
        businessAvatar={
          questDetailsData?.data?.quest_business?.business?.avatar_data
            ?.file_path
        }
        quotaType={quotaType}
        thumbnails={thumbnailPaths}
        menuIcon={images.ThreeDotBlueIcon}
        onMenuClick={() => setIsDropDownOpen(!isDropDownOpen)}
        isDropDownOpen={isDropDownOpen}
        onDropDownPauseClick={() => modalRefs.pause.current?.openModal()}
        onDropDownEndClick={() => modalRefs.end.current?.openModal()}
        onDropReportClick={handleDropReportClick}
      />

      <div className="flex flex-col flex-1 justify-between  overflow-y-hidden">
        <div
          ref={contentRef}
          className="flex-1 overflow-y-auto section-content pb-[200px]  scrollbar-hide"
        >
          {renderQuestionContent()}
        </div>

        {!(state.currentStep === 1 && isValidationReceipt) &&
          questType !== "REFERRAL" && (
            <div
              className={cn(
                "fixed bottom-0 left-0 right-0  z-[19] w-full ",
                "max-w-[480px] mx-auto",
                "flex flex-col gap-3.5 p-0 pt-[18px] pb-6",
              )}
              style={{
                background:
                  "linear-gradient(0deg, #fff 0%, rgba(255,255,255,0.9) 75%, rgba(255,255,255,0) 100%)",
              }}
            >
              <div className="flex flex-row justify-between items-center ">
                {renderPrevButton()}
                {/* <button
                className={cn(
                  "flex items-end justify-center rounded-xl min-h-[54px] w-[45px]",
                  "transition-all duration-300 ease-in-out",
                  isPrevStepLoading
                    ? "opacity-100 visible cursor-not-allowed"
                    : !state.reviewMode &&
                      state.currentStep <= (isValidationReceipt ? 2 : 1)
                    ? "opacity-0 invisible pointer-events-none"
                    : "opacity-100 visible"
                )}
                onClick={() => handlePrevStep()}
                disabled={
                  isPrevStepLoading ||
                  (!state.reviewMode &&
                    state.currentStep <= (isValidationReceipt ? 2 : 1))
                }
              >
                <img
                  src={images.ArrowRightIconBlue}
                  className="w-7 aspect-square transform -scale-x-100"
                  alt="Previous"
                />
              </button> */}

                <div className="px-2 mb-1">
                  <ProgressDotGroup
                    // currentStep={
                    //   isValidationReceipt
                    //     ? state.currentStep - 1
                    //     : state.currentStep
                    // }
                    currentStep={state.currentStep}
                    totalSteps={totalSteps}
                    isReviewed={
                      Object.keys(state.questAnswers).length ===
                        totalSteps - 1 || state.reviewMode
                    }
                    listAnwserErr={Object.values(state.questErrors || {})}
                    listQuestion={data?.data || []}
                    questAnswers={state.questAnswers}
                    submittedSteps={submittedSteps}
                    isValidationReceipt={isValidationReceipt}
                  />
                </div>

                {renderNextButton()}
              </div>
            </div>
          )}
      </div>

      <CommonModal
        ref={modalRefs.pause}
        canClickOverLay={false}
        showCloseIcon={false}
        classNameModal="p-6"
        actions={(closeModal) => (
          <>
            <Button
              text={t("base.pause")}
              className={cn(
                "flex-1 mt-0 gap-0 px-6 py-3 rounded-md min-h-[40px] text-xl leading-none font-medium  border border-[#253FF6] text-[#253FF6]",
              )}
              onClick={handlePauseTakeQuest}
            />
            <Button
              text={t("base.cancel")}
              className="flex-1 mt-0 gap-0 px-6 py-3 rounded-md min-h-[40px] text-xl leading-none font-medium text-white bg-[#253FF6] "
              onClick={() => closeModal(false)}
            />
          </>
        )}
      >
        <div className="flex flex-col items-center w-full gap-6">
          <div className="flex flex-col gap-1.5 items-center">
            <img
              src={images.CarbonPauseOutlineBlue}
              alt="Pause quest"
              className="w-6"
            />
            <div className="font-medium text-2xl text-[#253FF6]">
              {t("base.pauseThisQuest")}
            </div>
          </div>

          <div className="font-medium text-lg text-[#333333] text-center">
            {t("base.pauseQuestConfirmDescription")}
          </div>
          <div className="flex flex-col gap-1.5 items-center">
            <div className="font-medium text-sm text-[#A0A0A0] text-center">
              {t("base.remainingTime")}
            </div>
            <Timer
              className={"mt-0"}
              time={state.time}
              handleEndQuest={handleEndQuest}
              questId={questId}
              // typeImageOclock={true}
            />
          </div>
        </div>
      </CommonModal>

      <CommonModal
        ref={modalRefs.end}
        classNameText="font-semibold"
        classNameModal="p-6"
        canClickOverLay={false}
        showCloseIcon={false}
        actions={(closeModal) => (
          <>
            <Button
              text={t("base.quit")}
              className="flex-1 mt-0 gap-0 px-6 py-3 rounded-md min-h-[40px] text-xl font-medium  border border-[#253FF6] text-[#253FF6] leading-none"
              onClick={handleEndQuest}
            />
            <Button
              text={t("base.cancel")}
              className="flex-1 mt-0 gap-0 px-6 py-3 rounded-md min-h-[40px] text-xl font-medium text-white bg-[#253FF6] leading-none"
              onClick={() => closeModal(false)}
            />
          </>
        )}
      >
        <div className="flex flex-col items-center w-full gap-6 ">
          <div className="flex flex-col gap-1.5 items-center">
            <img
              src={images.CarbonCloseOutlineBlue}
              alt="End quest"
              className="w-6"
            />
            <div className="font-medium text-2xl text-[#253FF6]">
              {t("base.quitThisQuest")}
            </div>
          </div>

          <div className="font-medium text-lg text-[#333333] text-center">
            {t("base.quitQuestConfirmDescription")}
          </div>
        </div>
      </CommonModal>

      <CommonModal
        ref={modalRefs.submit}
        canClickOverLay={false}
        classNameModal="p-6"
        title={t("quest.detailMultipleChoice.submitQuest")}
        actions={(closeModal) => (
          <>
            <Button
              text={t("base.cancel")}
              className="flex-1 mt-0 gap-0 px-5 py-3 rounded-xl min-h-[40px] bg-white border border-stone-200 text-[#A0A0A0]"
              onClick={() => closeModal(false)}
            />
            <Button
              text={t("base.review")}
              className="flex-1 mt-0 gap-0 px-5 py-3 rounded-xl min-h-[40px] text-white bg-[#253FF6]"
              variant="primary"
              onClick={handleReview}
            />
          </>
        )}
      >
        <div className="flex flex-col items-center w-full">
          <ProgressBar
            currentStep={state.currentStep}
            totalSteps={totalSteps}
            errorSteps={state.questErrors}
            isReviewed={
              isReviewingDataResponse?.missing_or_not_correct_questions
                ?.length > 0 || Object.keys(state.questErrors).length > 0
            }
            hasReceiptIssue={isReviewingDataResponse?.ocr_receipt_job}
            hasReceiptIssueLocation={isReviewingDataResponse?.is_location}
            hasReceiptIssueDate={isReviewingDataResponse?.is_time}
          />
          <img
            src={images.SubmitQuestImageModal}
            alt="Submit quest"
            className="mt-6 w-[80px] aspect-[1.41]"
          />
        </div>
      </CommonModal>

      {/* <CommonModal
        ref={modalRefs.reviewComplete}
        canClickOverLay={false}
        showCloseIcon={false}
        classNameText="text-[#201D1B] font-medium text-lg"
      >
        <div className="flex flex-col items-center w-full gap-2 px-2">
          <img
            src={images.ReviewingQuestCompletedImage}
            alt="End quest"
            className="w-[170px]"
          />
          <div className="font-medium text-2xl text-[#253FF6]">
            {t(
              "quest.detailMultipleChoice.improveYourResponsesToUnlockYourRewards"
            )}
          </div>
          {Object.keys(state.questErrors).length > 0 && (
            <div className="font-medium text-lg text-[#333333] text-center">
              {t(
                "quest.detailMultipleChoice.thereAreQuestionsThatCouldUseYourAttention",
                {
                  count: Object.keys(state.questErrors).length,
                }
              )}
            </div>
          )}

          {Object.keys(state.questErrors).length > 0 && (
            <button
              onClick={handleBackQuest}
              className={
                "flex-1 shrink gap-2.5 px-5 py-4 rounded-xl w-full text-white text-base font-medium border-none mt-4 bg-[#253FF6]"
              }
            >
              <span className="flex items-center justify-center">
                {t("base.edit")}
              </span>
            </button>
          )}

          <div className="text-sm font-medium text-[#A0A0A0] text-center mt-4">
            <span>{t("quest.detailMultipleChoice.encounteringIssues")}</span>
            <br />
            <span
              onClick={isCompletingQuest ? undefined : () => handleComplete()}
              className={`border-b border-[#A0A0A0] ${
                isCompletingQuest
                  ? "cursor-not-allowed opacity-50"
                  : "cursor-pointer"
              }`}
            >
              {" "}
              {t("quest.detailMultipleChoice.requestForManualReview")}
            </span>
          </div>
        </div>
      </CommonModal> */}
      <CommonModal
        ref={modalRefs.reviewComplete}
        canClickOverLay={false}
        showCloseIcon={false}
        classNameText="text-[#201D1B] font-medium text-lg"
        classNameModal="p-6 bg-[#F5E3E6]"
        classNameBodyModal="bg-white max-h-[80vh] xs:max-h-[90vh]"
      >
        <div className="flex flex-col items-center w-full gap-4 xs:gap-6">
          <div className="text-[#253FF6] text-center font-[Figtree] text-base font-semibold ">
            <span>{t("quest.questDetails.responseEvaluation")}</span>
          </div>
          <div className="flex flex-col justify-center p-4 xs:p-6 items-center self-stretch  h-[180px] xs:h-[240px] [&>div]:h-full">
            <Lottie
              animationData={require("../../../images/animation/sorry.json")}
            />
            {/* <img
              src={images.ReviewReceiptImage}
              alt="Receipt Illustration"
              className={cn(
                modalContent?.primaryMessageKeys?.length > 1
                  ? "w-[full] h-[full]"
                  : "w-[full] h-[full]"
              )}
            /> */}
          </div>
          <div className="text-[#253FF6] text-center font-[Figtree] text-xl xs:text-2xl font-semibold ">
            <span>
              {t(
                "quest.detailMultipleChoice.improveYourResponsesToUnlockYourRewards",
              )}
            </span>
          </div>

          {Object.keys(state.questErrors).length > 0 && (
            <div className="font-medium text-sm xs:text-lg text-[#333333] text-center">
              {Object.keys(state.questErrors).length === 1
                ? t(
                    "quest.detailMultipleChoice.oneQuestionsRequiresYourAttention",
                  )
                : t(
                    "quest.detailMultipleChoice.moreQuestionsRequireYourAttention",
                    {
                      count: Object.keys(state.questErrors).length,
                    },
                  )}
            </div>
          )}
          {Object.keys(state.questErrors).length > 0 && (
            <button
              onClick={handleBackQuest}
              className={
                "flex-1 shrink gap-0 px-4 py-3 xs:px-5 xs:py-4 rounded-xl w-full text-white text-sm xs:text-xl font-medium border-none bg-[#253FF6]"
              }
            >
              <span className="flex items-center justify-center">
                {t("base.edit")}
              </span>
            </button>
          )}

          <div className="text-xs xs:text-sm font-medium text-[#A0A0A0] text-center">
            <span>{t("quest.detailMultipleChoice.encounteringIssues")}</span>
          </div>

          <div className="text-sm xs:text-base font-medium text-[#A0A0A0] text-center p-1.5">
            <span
              onClick={isCompletingQuest ? undefined : () => handleComplete()}
              className={`border-b border-[#A0A0A0] ${
                isCompletingQuest
                  ? "cursor-not-allowed opacity-50"
                  : "cursor-pointer"
              }`}
            >
              {" "}
              {t("quest.detailMultipleChoice.requestForManualReview")}
            </span>
          </div>
        </div>
      </CommonModal>

      <CommonModal
        ref={modalRefs.reviewingComplete}
        title={t("quest.detailMultipleChoice.questCompleted")}
        canClickOverLay={false}
        actions={(closeModal) => (
          <>
            <Button
              text={t("base.retry")}
              className="flex-1 gap-0 mt-0 px-5 py-3 rounded-xl min-h-[40px] bg-white border border-stone-200 text-[#A0A0A0]"
              onClick={() => closeModal(false)}
            />
            <Button
              text={t("base.submit")}
              className="flex-1 gap-0 mt-0 px-5 py-3 rounded-xl min-h-[40px] text-white bg-[#253FF6]"
              variant="primary"
              onClick={() => handleComplete()}
            />
          </>
        )}
      >
        {congratulation && (
          <div className="flex flex-col items-center w-full">
            <img
              loading="lazy"
              src={images.ReviewCompleteQuestImageModal}
              alt="Quest illustration"
              className="object-contain mt-6 max-w-full aspect-[1.41] w-[80px]"
            />
            <span>
              {t(
                "quest.detailMultipleChoice.congratulationsOnYourNewAchievement",
              )}
            </span>
          </div>
        )}
      </CommonModal>

      <CommonModal
        ref={outQuestModelRef}
        title={t("quest.detailMultipleChoice.timeUp")}
        classNameText="text-[#201D1B] font-medium text-lg "
        classNameModal="p-6"
        canClickOverLay={false}
        actions={(closeModal) => (
          <>
            <Button
              text={t("base.ok")}
              className="flex-1 shrink gap-0 mt-0 self-stretch px-5 py-3 rounded-xl min-h-[40px] text-white bg-[#253FF6]"
              variant="primary"
              onClick={() => {
                closeModal();
                handleSaveQuest();
              }}
            />
          </>
        )}
      >
        <div className="flex justify-center items-center w-full px-4">
          <span className="text-sm font-normal text-[#787A7A] break-words text-wrap text-center">
            {t("quest.detailMultipleChoice.missionHasEndPleaseExitAndTryAgain")}
          </span>
        </div>
      </CommonModal>

      <CommonModal
        ref={timeIsRunningRef}
        classNameText="text-[#201D1B] font-medium text-lg "
        classNameModal="p-6"
        canClickOverLay={false}
        actions={(closeModal) => (
          <>
            <Button
              text={t("quest.detailMultipleChoice.saveAndQuit")}
              className="flex-1 mt-0 shrink gap-0  self-stretch rounded-md min-h-[40px] text-[#253FF6] bg-[#fff] border border-[#253FF6] text-xl font-medium text-center"
              variant="primary"
              onClick={() => {
                closeModal();
                confirmSaveAndQuitRef.current?.openModal();
              }}
            />
            <Button
              text={t("quest.detailMultipleChoice.extend")}
              className="flex-1 mt-0 shrink gap-0  self-stretch rounded-md min-h-[40px] text-white bg-[#253FF6] text-xl font-medium text-center"
              variant="primary"
              onClick={() => {
                handleExtendTime();
              }}
            />
          </>
        )}
      >
        <div className="flex flex-col justify-center items-center w-full gap-6">
          <div className="flex flex-col items-center gap-1.5">
            <img src={images.OclockIconRed} alt="" />
            <span className="text-2xl font-medium text-[#EF4056]  text-center">
              {t("quest.detailMultipleChoice.timeIsRunningOut")}
            </span>
          </div>

          <span className="text-lg font-medium text-[#333333]  text-center">
            {t("quest.detailMultipleChoice.yourTimeIsAlmostUp")}
          </span>

          <div className="flex flex-col items-center gap-1.5">
            <span className="text-sm text-[#A0A0A0] font-medium">
              {t("base.remainingTime")}
            </span>
            <TimerTypeOclock time={diffSeconds} />
          </div>
        </div>
      </CommonModal>

      <CommonModal
        ref={confirmSaveAndQuitRef}
        classNameText="text-[#201D1B] font-medium text-lg "
        classNameModal="p-6"
        canClickOverLay={false}
        actions={(closeModal) => (
          <>
            <Button
              text={t("base.cancel")}
              className="flex-1 mt-0 shrink gap-0 self-stretch rounded-md min-h-[40px] text-[#253FF6] bg-[#fff] border border-[#253FF6] text-xl font-medium text-center"
              variant="primary"
              onClick={() => {
                closeModal();
              }}
            />
            <Button
              text={t("quest.detailMultipleChoice.saveAndQuit")}
              className="flex-1 mt-0 shrink gap-0 self-stretch rounded-md min-h-[40px] text-white bg-[#253FF6] text-xl font-medium text-center"
              variant="primary"
              onClick={() => {
                closeModal();
                handleSaveQuest();
              }}
            />
          </>
        )}
      >
        <div className="flex flex-col justify-center items-center w-full gap-6">
          <div className="flex flex-col items-center gap-1.5">
            <img src={images.SaveIcon} alt="" />
            <span className="text-2xl font-medium text-[#08B89D]  text-center">
              {t("quest.detailMultipleChoice.saveAndQuit")}
            </span>
          </div>

          <span className="text-lg font-medium text-[#333333]  text-center">
            {t(
              "quest.detailMultipleChoice.yourResponsesWillBeSavedButYourSlotWillBeReleased",
            )}
          </span>
        </div>
      </CommonModal>

      <CommonModal
        ref={modalRefs.reviewQuestModal}
        classNameText="text-[14px] font-medium text-[#253FF6]"
        showCloseIcon={false}
        canClickOverLay={false}
        classNameModal="p-6"
        classNameBodyModal=" bg-[#ECEEFF] p-0"
      >
        <BodyModalLoading
          progress={progress}
          text={t("quest.questDetails.rallyTips")}
          loadingText={t("quest.questDetails.reviewingResponses")}
          animationSrc={"message-stars.json"}
          tipsText1={t("quest.questDetails.dontJustSayGood")}
        />
      </CommonModal>
      <CommonModal
        ref={modalRefs.editQuestModal}
        classNameText="text-[14px] font-medium text-[#253FF6]"
        showCloseIcon={false}
        canClickOverLay={false}
        classNameModal="p-6"
        classNameBodyModal=" bg-[#ECEEFF] p-0"
      >
        <BodyModalLoading
          progress={progress}
          text={t("quest.questDetails.rallyTips")}
          loadingText={t("quest.questDetails.reviewingResponses")}
          animationSrc={"eating-salad.json"}
          tipsText1={t("quest.questDetails.badExperiencesMatterToo")}
          iconText1="👎"
          conclusionText={t("quest.questDetails.shareWhatWentWrong")}
        />
      </CommonModal>
      <CommonModal
        ref={modalRefs.completeReviewModal}
        classNameText="text-[14px] font-medium text-[#253FF6]"
        showCloseIcon={false}
        canClickOverLay={false}
        classNameModal="p-6 bg-[#E1D2F3]"
        classNameBodyModal="p-9"
      >
        <StepQuestComplete />
      </CommonModal>
    </div>
  );
};
export default DetailMultipleChoice;
